/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type TemplatesQuoteStatus_TemplateFragment = { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, accessType: Types.TemplateAccessType, owningSystemOrganisationId: string, hasAnyPublishedVersion: boolean, containsUnpublishedChanged: boolean, templateSharing?: { __typename: 'TemplateSharing', id: string, latestSharedVersionNumber: number, sharedPublicly: boolean, subscribedToTemplate?: { __typename: 'TemplateSubscription', subscribedVersionNumber: number, updateAvailable: boolean } | null } | null };

export const TemplatesQuoteStatus_TemplateFragmentDoc = gql`
    fragment TemplatesQuoteStatus_Template on QuoteTemplate {
  id
  resolvedAsReadModelVersionNumber
  accessType
  templateSharing {
    id
    latestSharedVersionNumber
    sharedPublicly
    subscribedToTemplate {
      subscribedVersionNumber
      updateAvailable
    }
  }
  owningSystemOrganisationId
  hasAnyPublishedVersion
  containsUnpublishedChanged
}
    `;